import {Link} from '../ui/ScopedLink';
import {DataTable} from '../ui/DataTable';
import {StatusBadge} from '../ui/StatusBadge';
import type {Contact} from './Contacts';

export function ContactDirectoryTable({rows}:{rows:Contact[];canEdit:boolean}){
 const path=(row:Contact)=>'/records/'+row.type.toLowerCase()+'/'+row.id;
 return <DataTable compact caption={<span className="sr-only">People and organisations in this directory view</span>} scrollLabel="Contact records" rows={rows} getRowKey={row=>row.type+':'+row.id}
 rowHeader={{id:'name',header:'Name',render:row=><Link className="data-table__record-link" to={path(row)}>{row.name}</Link>}}
 columns={[
  {id:'type',header:'Record type',render:row=>row.type},
  {id:'relationships',header:'Relationship',render:row=><span title={row.roles.map(role=>role.label).join(', ')}>{row.roles[0]?.label??'Not recorded'}{row.roles.length>1?` +${row.roles.length-1}`:''}</span>},
  {id:'status',header:'Recorded status',render:row=><StatusBadge text={row.status||'Not recorded'}/>},

 ]}/>;
}
